export type RecallState = 'held' | 'due' | 'missed' | 'unseen' | 'none';

/** Graph fill for a recall value: hollow, hatched or solid. */
export function recallFill(state: RecallState, recall?: number | null): 'hollow' | 'hatched' | 'solid' {
  if (state === 'unseen' || state === 'none' || recall == null) return 'hollow';
  if (state === 'held' && recall >= 0.9) return 'solid';
  return 'hatched';
}

/** "R .62" as the margin card prints recall. */
export function recallLabel(recall?: number | null): string | undefined {
  if (recall == null) return undefined;
  return `R ${recall.toFixed(2).replace(/^0/, '')}`;
}

/** Score copy after grading: 3 of 4 -> "3/4". */
export function score(got: number, total: number): string {
  return `${got}/${total}`;
}

export const questionKindLabel: Record<string, string> = {
  explain: 'Explain',
  predict: 'Predict',
  compare: 'Bridge',
  flaw: 'Find the flaw',
  apply: 'Apply',
};
